import { useCallback } from "react";

export function useGeneralInputSpecialCase(setState) {
    return useCallback((field, value) => {
        setState(prev => ({
            ...prev,
            [field]: value ?? null
        }));
    }, [setState]);
}

export function useGeneralInputSpecialCaseComplexObj(setState) {
    return useCallback((obj, field, value) => {
        setState(prev => ({
            ...prev,
            [obj]: {
                ...prev[obj],
                [field]: value ?? null
            }
        }));
    }, [setState]);
}
export function useGeneralInput(setState) {
    return useCallback((event) => {
        const { id, name, value } = event.target;

        const field = name || id;

        setState(prev => ({
            ...prev,
            [field]: value
        }));

    }, [setState]);
}

